export const SEND_TEST_EMAIL_FORM_KEYS = {
  mailto: "mailto",
  comm_name: "comm_name",
  listing_uuid: "listing_uuid",
};
